import type { ProductProps } from "~/types";
import { ButtonWithArrow, Text, Title, Wrapper } from "~/ui";
import { CursiveBasic } from "~/ui/cursive-basic";

import { EmblaCarouselProducts } from "../carousel/slider-products";

export const BlockProducts = ({ products }: ProductProps) => {
  const preferredProductsSlugs = [
    "tucker-tub-chicken-rice-stew",
    "tucker-tub-beef-casserole",
    "tucker-tub-savoury-chicken-loaf",
    "tucker-tub-raw-turkey-vegetable",
    "tucker-tub-raw-beef-vegetable",
    "tucker-tub-raw-chicken-vegetable",
    "tucker-tub-raw-veal-bones",
    "tucker-tub-raw-kangaroo-tails",
    "tucker-tub-beef-jerky",
  ];

  const clientPreferredProducts = products?.filter((product) =>
    preferredProductsSlugs?.includes(product?.slug)
  );

  return (
    <div className="mt-[-130px] h-full w-full overflow-hidden bg-colorFourteen pt-44 pb-10">
      <Wrapper>
        <div className="grid grid-cols-1 gap-x-8 text-left sm:grid-cols-[2fr_1fr]">
          <Title heading="h1" className="col-span-full text-colorFifteen">
            Fresh & Healthy Dog Food
          </Title>
          <div>
            <CursiveBasic heading="h3">
              All natural dog food, made farm fresh
            </CursiveBasic>
            <Text className="text-colorFifteen">
              Tucker Tub offers a selection of healthy dog food options,
              including cooked and raw dog food, hand crafted with fresh, local
              ingredients in country Victoria and Melbourne delivered right to
              your door. Free from preservatives, additives, and fillers, our
              fresh dog food are approved by vets and pet nutritionists. You can
              trust that your pup is getting the nutrients they need; no fluff,
              just real, fresh, natural dog food.
            </Text>
          </div>
          <div className="py-10">
            <ButtonWithArrow
              center
              href="/shop/raw-dog-food"
              className="w-full xs:w-[310px] lg:w-[240px]"
            >
              Raw Dog Food
            </ButtonWithArrow>
            <ButtonWithArrow
              center
              href="/shop/cooked-dog-food"
              className="w-full xs:w-[310px] lg:w-[240px] mt-2"
            >
              Cooked Dog Food
            </ButtonWithArrow>
          </div>
        </div>
      </Wrapper>
      <div className="container h-full w-full py-8">
        {clientPreferredProducts && clientPreferredProducts?.length > 0 ? (
          <EmblaCarouselProducts productData={clientPreferredProducts} />
        ) : (
          <div className="text-center">
            <Title className="pt-6 text-colorFourteen">No products found</Title>
          </div>
        )}
      </div>
    </div>
  );
};
